import React, { Suspense, useEffect } from 'react'
import { Outlet, useLocation, Routes, Route, Navigate } from 'react-router-dom'
import { PageDataProvider } from '../_metronic/layout/core'
import { HeaderWrapper } from '../_metronic/layout/components/header'
import { reInitMenu } from '../_metronic/helpers/react18MigrationHelpers'
import { Sidebar } from '../_metronic/layout/components/sidebar'
import { FooterWrapper } from '../_metronic/layout/components/footer'
import { ScrollTop } from '../_metronic/layout/components/scroll-top'
import Loader from '../components/Loader'
import routes from '../../routes'
import { MasterInit } from '../_metronic/layout/MasterInit'
import AreYouSureModal from '../modals/AreYouSureModal'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import FastDriver from '../components/FastDriver'
import FastFirm from '../components/FastFirm'
import FastVehicle from '../components/FastVehicle'
import Page404Screen from '../screens/Page404Screen/Page404Screen'
import EbbeModal from '../modals/EbbeModal'
import JobQueueProgress from '../components/JobQueueProgress'

const Layout = () => {
    const location = useLocation()
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        reInitMenu()
    }, [location.key])

    return (
        <PageDataProvider>
            <div className={'d-flex flex-column flex-root app-root'} id='kt_app_root'>
                {/* <div className={'d-flex flex-column flex-root app-root ' + (auth.fastFirm ? 'custom-overflow-hidden' : undefined)} id='kt_app_root'> */}

                <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
                    <HeaderWrapper />
                    <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                        <Sidebar />
                        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                            <div className='d-flex flex-column flex-column-fluid'>
                                <Suspense fallback={<Loader />}>
                                    <Routes>
                                        {routes(auth.user.user?.data.authorizedMenus).map((route, idx) => {
                                            return (
                                                route.element && (
                                                    <Route
                                                        key={idx}
                                                        path={route.path}
                                                        // exact={route.exact}
                                                        // name={route.name}
                                                        element={<route.element />}
                                                    />
                                                )
                                            )
                                        })}
                                        <Route path="/" element={<Navigate to="dashboard" replace />} />
                                        <Route path="*" element={<Page404Screen />} />
                                    </Routes>
                                </Suspense>
                            </div>
                            {/* <FooterWrapper /> */}
                        </div>
                    </div>
                </div>
            </div>

            <AreYouSureModal isShown={auth.areYouSureModalCallback !== undefined} onClose={auth.areYouSureModalCallback} />

            <EbbeModal isShown={!!auth.ebbeModalCallback} params={auth.ebbeModalCallback} />

            <JobQueueProgress />

            {
                auth.fastFirm && (
                    <FastFirm
                        companyId={auth.fastFirm.companyId}
                        isAgency={auth.fastFirm.isAgency}
                        isAirlineFirm={auth.fastFirm.isAirlineFirm}
                        isCompany={auth.fastFirm.isCompany}
                        isCustomer={auth.fastFirm.isCustomer}
                        isDutyFirm={auth.fastFirm.isDutyFirm}
                        isReceiverFirm={auth.fastFirm.isReceiverFirm}
                        isSeawayFirm={auth.fastFirm.isSeawayFirm}
                        isSenderFirm={auth.fastFirm.isSenderFirm}
                        isSupplier={auth.fastFirm.isSupplier}
                        onSubmit={auth.fastFirm.onSubmit}
                        addressTypeId={auth.fastFirm.addressTypeId}
                        isJustAddress={auth.fastFirm.isJustAddress}
                        allowedFields={auth.fastFirm.allowedFields}
                        defaultInitialCompanyTypeId={auth.fastFirm.defaultInitialCompanyTypeId}
                        isRepresentative={auth.fastFirm.isRepresentative}
                        onFirmaTanimli={auth.fastFirm.onFirmaTanimli}
                    />
                )
            }

            {
                auth.fastDriver && (
                    <FastDriver
                        relatedCompanyId={auth.fastDriver.relatedCompanyId}
                        relatedCompanyName={auth.fastDriver.relatedCompanyName}
                        onSubmit={auth.fastDriver.onSubmit}
                    />
                )
            }

            {
                auth.fastVehicle && (
                    <FastVehicle
                        ownerCompanyId={auth.fastVehicle.ownerCompanyId}
                        ownerCompanyName={auth.fastVehicle.ownerCompanyName}
                        driverId={auth.fastVehicle.driverId}
                        driverName={auth.fastVehicle.driverName}
                        ownerEditable={auth.fastVehicle.ownerEditable}
                        onSubmit={auth.fastVehicle.onSubmit}
                    />
                )
            }

            <MasterInit />

            {/* <ActivityDrawer />
            <RightToolbar />
            <DrawerMessenger />

            <InviteUsers />
            <UpgradePlan /> */}
            <ScrollTop />
        </PageDataProvider>
    )
}

export default Layout;